import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { getValueForKey } from "../../../context/translationsUtils";
import { TranslationContextInterface } from "../../../entities/Language";
import { TranslationContext } from "../../../context/TranslationContext";
import TooltipComponent from "../../TooltipComponent";
import { useAppDispatch } from "../../../store/store";
import { onOpenModal } from "../../Modal/slice/ModalSlice";
import { MODAL_TYPES } from "../../../entities/Modal";
import { useSelector } from "react-redux";
import { getDataFromMixture } from "../../Mixture/selectors";
import { getCalculatedVolume } from "../../Calculation/slice/selectors";
import { setJars } from "../../Mixture/MixtureSlice";
import { TEST_ID } from "../../../shared/testid";

const CustomizeSelectJars: React.FC = () => {
  const [inputJarsDisabled, setInputJarsDisabled] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);

  const { jars, nrJarsLimitPerMix, selectedWeight } =
    useSelector(getDataFromMixture);
  const { maxVolumeOfMix: maxWeight } = useSelector(getCalculatedVolume);

  useEffect(() => {
    if (selectedWeight === maxWeight) {
      setInputJarsDisabled(false);
    }
    if (!inputJarsDisabled && selectedWeight < maxWeight) {
      setInputJarsDisabled(true);
      dispatch(setJars(1));
    }
  }, [selectedWeight, maxWeight, inputJarsDisabled, dispatch]);

  const onReachMaxJars = () => {
    const description = getValueForKey(translations, "alerts.max_jar", {
      jars: nrJarsLimitPerMix.toString(),
    });
    dispatch(
      onOpenModal({
        modalType: MODAL_TYPES.ALERT,
        content: {
          name: getValueForKey(translations, "edit_mix.sidebar_number_of_jars"),
          description,
        },
      }),
    );
    dispatch(setJars(nrJarsLimitPerMix));
  };

  const handleNumberOfJars = (e: ChangeEvent<HTMLInputElement>) => {
    const currentTargetValue = parseFloat(e.currentTarget.value);
    dispatch(setJars(currentTargetValue));
    if (currentTargetValue > nrJarsLimitPerMix) {
      onReachMaxJars();
    }
  };

  const onBlurNumberOfJars = (e: ChangeEvent<HTMLInputElement>) => {
    const currentTargetValue = parseFloat(e.currentTarget.value);
    if (currentTargetValue < 1 || isNaN(currentTargetValue)) {
      dispatch(setJars(1));
    }
  };

  return (
    <div className="customized-group">
      <label>
        {getValueForKey(translations, "edit_mix.sidebar_number_of_jars")}:
      </label>
      <div className="customized-group__input" id="input-jars">
        <input
          type="number"
          onChange={handleNumberOfJars}
          value={jars}
          min={1}
          data-testid={TEST_ID.CREATE_MIX.JAR_QUANTITY}
          disabled={inputJarsDisabled}
          onBlur={onBlurNumberOfJars}
        />
      </div>
      {inputJarsDisabled && (
        <TooltipComponent anchor="#input-jars" place="bottom">
          <div className="input-jars">
            <div className="input-jars__title">
              {getValueForKey(translations, "edit_mix.full_jars_modal_title")}
            </div>
            <div className="input-jars__description">
              {getValueForKey(translations, "edit_mix.full_jars_modal_text")}
            </div>
          </div>
        </TooltipComponent>
      )}
    </div>
  );
};

export default CustomizeSelectJars;
